import { z } from "zod";

export const OrderBy = {
  CERTIFICATION_ID: "CERTIFICATION_ID",
  CERTIFICATION_NAME: "CERTIFICATION_NAME",
  CERTIFICATION_PARTY: "CERTIFICATION_PARTY",
  EFFECTIVE_DATE: "EFFECTIVE_DATE",
  EXPIRATION_DATE: "EXPIRATION_DATE",
  RENEWAL_DATE: "RENEWAL_DATE",
  CERTIFICATION_HOLDER: "CERTIFICATION_HOLDER",
} as const;

export const EducationAndQualificationSearchSchema = z.object({
  sortOrder: z.enum(["asc", "desc"]).default("asc").optional(),
  sortColumn: z
    .union([
      z.nativeEnum(OrderBy),
      z.enum([
        "certificationId",
        "certificationName",
        "certificationParty",
        "effectiveDate",
        "expirationDate",
        "renewalDate",
        "certificationHolder",
      ]),
    ])
    .optional(),
  freeText: z.string().optional(),
  page: z.number().default(1),
  pageSize: z.number().default(100),
});
